import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Location } from '@angular/common';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CreateNewSmsInformationForOrganizationsCommand,
  SendTypes,
} from 'src/app/core/api/models';
import { InformationsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { RoutingStateService } from 'src/app/core/services/routing-state.service';
import { TransferDataService } from 'src/app/core/services/transfer-data.service';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { DateTimeConfig } from 'src/app/shared/components/date-time-picker/date-time-picker.component';
import { PageHeaderBtnComponent } from 'src/app/shared/components/page-header-btn/page-header-btn.component';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
  selector: 'app-create-sms-information-form',
  imports: [BaseFormModule, SmsBodyModule, PageHeaderBtnComponent],
  templateUrl: './create-sms-information-form.component.html',
  styleUrls: [
    '../../../sending-system/base/base-sending-system.component.scss',
  ],
})
export class CreateSmsInformationFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  location = inject(Location);
  routingState = inject(RoutingStateService);

  protected currentService = inject(InformationsService);
  model: CreateNewSmsInformationForOrganizationsCommand = {};
  isCanSendVoice: boolean;
  directDateTimeConfig: DateTimeConfig;
  informationId: number;
  tabName: string = 'createSmsInformation';

  get SendTypes() {
    return SendTypes;
  }
  displaySmsText;
  //#endregion

  constructor(private tabsDynamicComponent: TabsDynamicComponent) {
    super();
    this.informationId = TransferDataService.id;
  }

  ngOnInit() {
    // اگر کاربر با انتخاب گزینه در پرنت آمده بود آیدی پرنت رو به یوآرال اضافه میکنیم و اگر با یوآرال آمده بود آیدی پرنت رو از یوآرال میخونیم
    if (this.informationId && !window.location.search.includes('key-')) {
      this.location.go(
        window.location.pathname +
          window.location.search +
          '?' +
          QueryStringTypesEnum.SendInformation_key +
          '=' +
          this.informationId
      );
    } else {
      let params = this.routingState.parseQueryString();
      for (const [key, value] of Object.entries(params)) {
        if (key == QueryStringTypesEnum.SendInformation_key) {
          this.informationId = +value;
        }
      }
    }

    this.getInformationDetailForSendSms();
    this.initForm();
    this.setComponentsConfig();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      smsBody: new FormControl('', [Validators.required]),
      senderNumberId: new FormControl('', Validators.required),
      sendDate: new FormControl(''),
      sendTime: new FormControl(''),
    });
  }

  setComponentsConfig() {
    try {
      this.directDateTimeConfig = {
        dateLabel: 'common.sendDay',
        timeLabel: 'common.sendHour',
        dateFormControl: this.form?.get('sendDate') as FormControl,
        timeFormControl: this.form?.get('sendTime') as FormControl,
        minDateType: 'today',
        isDefaultValue: true,
        isConvertToIsoString: false,
        isEditMode: false,
        responsiveClassName: 'xl:tw-w-1/2 tw-w-full tw-px-1',
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region Api
  getInformationDetailForSendSms() {
    this.unSubs();

    this.loading = true;

    this.currentService
      .informationsGetInformationDetailForSendSms({ Id: this.informationId })
      .pipe(this.basePipeOperators())
      .subscribe(
        (result: any) => {
          if (result.isSucceed) {
            this.displaySmsText = this.rawContent(result.data.contentText);
            this.model.targetOrganizationIds =
              result.data.organizationIdListForShow;
          }
        },
        (error) => {
          ConsoleService.error('error', error);
        },
        () => (this.loading = false)
      );
  }

  //Create
  baseCreateApi(model: CreateNewSmsInformationForOrganizationsCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .informationsCreateNewSmsInformationForOrganizations({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        this.onSuccess();
        this.refreshPage();
      });
  }

  //#endregion

  onSuccess() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'instant',
    });

    this.output_closeFormPage.emit(true);
    this.unSubs();
  }

  refreshPage() {
    this.tabsDynamicComponent.refreshTab(this.tabName);
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      if (this.formPageConfig.isEditMode) this.baseUpdateApi(this.model);
      else this.baseCreateApi(this.model);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  rawContent(html: string): string {
    if (!html) return '';

    // Replace <br> with newlines
    html = html.replace(/<br\s*\/?>/gi, '\n');

    // Replace block elements with newlines
    html = html.replace(/<\/(p|div|li|h[1-6]|blockquote)>/gi, '\n');

    // Create a temp element to parse
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Extract text with spacing preserved
    let text = tempDiv.textContent || tempDiv.innerText || '';

    // Normalize line endings (optional)
    text = text.replace(/\n{2,}/g, '\n'); // Optional: collapse multiple newlines

    return text.trim(); // Optional: trim extra whitespace at start/end
  }
}
